<div class="verify-main-container">

  <div class="card-container">

    <img src="./assets/img/logo/openpay.webp"
         srcset="./assets/img/logo/openpay@2x.webp 2x,
             ./assets/img/logo/openpay@3x.webp 3x"
         class="openpay-logo"
         alt="openpay logo"
    >

    <div class="verify-container">
      <img src="./assets/img/verify/verify.png"
           srcset="./assets/img/verify/verify@2x.png 2x,
             ./assets/img/verify/verify@3x.png 3x"
           class="verify-check"
           alt="openpay logo"
      >
    </div>

    <span class="verify-title">
      Verifica tu correo y contraseña
    </span>

    <div class="verify-content">
      <p>
        Al parecer no tienes una cuenta registrada con Openpay <br/>
        ¿Quieres crear una?
        <span class="go-back-hyperlink">
          Haz clic aquí
        </span>
      </p>
    </div>

  </div>

</div>
